export default __webpack_public_path__ + "static/new-moon-102cb7f9b91891658935ea97b952c69b.png";